import _ from 'lodash'

import i18n from '@/i18n/i18n'
import { PaymentReminderService } from '@/services/admin/PaymentReminderService'
import { build_query, errorMessage } from '@/utilities/helpers'

const { t } = i18n.global

export const namespaced = true

export const allowedFilters = ['remind_date', 'fullname', 'phone', 'reminder_assignee', 'phone_survey_option']

export const state = {
  reminders: [],
  reminder: {},
  meta: null,
  stats: [],
  statuses: []
}

export const mutations = {
  SET_REMINDERS(state, reminders) {
    state.reminders = reminders.data
    state.meta = reminders.meta
  },
  ADD_REMINDERS(state, reminders) {
    state.reminders.push(...reminders.data)
    state.meta = reminders.meta
  },
  SET_REMINDER(state, reminder) {
    if (state.reminder.id !== reminder.id) {
      _.set(state, 'reminder', reminder)
    }
  },
  DELETE_REMINDER(state, reminderToRemove) {
    state.reminders = state.reminders.filter(reminder => {
      return reminder.id !== reminderToRemove.id
    })
  },
  SET_STATS(state, data) {
    state.stats = data
  },
  SET_STATUSES(state, statuses) {
    state.statuses = statuses
  },
  UPDATE_REMINDER(state, reminder) {
    let position = _.findIndex(state.reminders, r => {
      return r.id === reminder.id
    })

    if (position === -1) {
      return
    }

    let newReminder = { 
      ...state.reminders[position],
      ...reminder,
      assignee: reminder.assignee || null
    }

    state.reminders.splice(position, 1, newReminder)
  }
}

export const actions = {
  getPaymentReminders({ commit }, query) {
    let newQuery = build_query(query, allowedFilters)
    return new Promise(resolve => {
      let paymentReminderService = new PaymentReminderService(newQuery)
      paymentReminderService.getPaymentReminders().then(response => {
        commit('SET_REMINDERS', response)
        resolve(response.data)
      })
    })
  },
  loadPaymentReminders({ commit, state }, query) {
    query.page = state.meta.current_page + 1
    let newQuery = build_query(query, allowedFilters)
    return new Promise(resolve => {
      let paymentReminderService = new PaymentReminderService(newQuery)
      paymentReminderService.getPaymentReminders().then(response => {
        commit('ADD_REMINDERS', response)
        resolve(response.data)
      })
    })
  },
  updatePaymentReminder({ state, dispatch }, reminder) {
    return new Promise((resolve, reject) => {
      let paymentReminderService = new PaymentReminderService()
      paymentReminderService
        .updatePaymentReminder(reminder.id, reminder)
        .then(response => {
          let notification = {
            type: 'success',
            message: t('store.admin.payment_reminder.update_payment_reminder_success')
          }

          if (reminder.hasOwnProperty('message')) {
            notification.message = reminder.message
          }

          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  sendPaymentReminderSMS({ dispatch }, id) {
    return new Promise((resolve, reject) => {
      let paymentReminderService = new PaymentReminderService()
      paymentReminderService
        .sendPaymentReminderSMS(id)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.payment_reminder.send_payment_reminder_sms_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getStats({ commit }) {
    return new Promise((resolve, reject) => {
      let paymentReminderService = new PaymentReminderService()
      paymentReminderService
        .stats()
        .then(response => {
          commit('SET_STATS', response)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getPhoneSurveyFilterOptions({ commit }) {
    return new Promise((resolve, reject) => {
      new PaymentReminderService()
        .phoneSurveyFilterOptions()
        .then(response => {
          commit('SET_STATUSES', response)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  updateReminder({ commit }, reminder) {
    commit('UPDATE_REMINDER', reminder)
  },
  assignOperation({ commit, dispatch }, reminders) {
    return new Promise((resolve, reject) => {
      let paymentReminderService = new PaymentReminderService()
      paymentReminderService
        .assign(reminders)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.payment_reminder.assign_operation_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
